import { defineStore } from 'pinia';
import { useSessionStore } from './sessionStore';
import { useApiClientStore } from './apiClientStore';
import { usePlayerStore } from './playerStore';

export const useTeamStore = defineStore('teamStore', 
{
    state: () =>
    ({
        myTeamId: undefined as string|undefined,

    }),

    actions: 
    {
        setMyTeamId(teamId:string): void
        {
            this.myTeamId = teamId;
        },

        async fetchMyTeamId(): Promise<string|undefined>
        {
            if(!useSessionStore().identity) return undefined;

            const playerStore = usePlayerStore();
            let player = playerStore.getCurrentPlayer || await playerStore.fetchCurrentPlayer();

            if(player?.teamId)
            {
                this.setMyTeamId(player.teamId)
            }

            return player?.teamId;
        },

        async leave(): Promise<void>
        {
            const playerStore = usePlayerStore();
            const player = playerStore.getCurrentPlayer;

            if(!player?.teamId || !player?.id) return;

            await useApiClientStore().teamApiClient.reject(player.teamId, player.id);
        }
    }
});